export default __webpack_public_path__ + "static/media/pin-gas.d02ce77e.svg";